module.exports = __webpack_public_path__ + "static/img/main-banner01.aa0e186e.png";